/* eslint new-cap:0 */

import React, { Component, PropTypes, Children } from 'react';
import ReactTransitionGroup from 'react-addons-transition-group';
import assign from 'object-assign';
import Radium from 'radium';
import Presenter from 'views/hudTeacherRemote/teacherRemote';
import HeadsUpDisplay from 'views/hudTeacherRemote/hud';
import Onboarding from '../../components/onboarding';
import NextSlideConfirmationModal from '../../components/nextSlideConfirmationModal';
import lodash from 'lodash';
import './deck.scss';

const Style = Radium.Style;
const TransitionGroup = Radium(ReactTransitionGroup);
const enableOnboarding = true;

@Radium
class Deck extends Component {
  constructor (props) {
    super(props);
    this._handleKeyPress = this._handleKeyPress.bind(this);
    this._toggleHUD = this._toggleHUD.bind(this);
    this._getDeckHeight = this._getDeckHeight.bind(this);
    this._togglePresenterMode = this._togglePresenterMode.bind(this);
    this.state = {
      lastSlide: null,
      hideCursor: false
    };
    this.oldPath = null;
  }

  getChildContext() {
    return {
      togglePresenterMode: this._togglePresenterMode
    };
  }

  componentWillMount () {
    this._createTOC(this.props);
    const { mode, deckState: { displayHUD }, showHUD } = this.context;
    if (mode && !displayHUD) {
      showHUD();
    }
  }

  componentDidMount () {
    setTimeout(() => { this._getDeckHeight(); }, 0);
    this._attachEvents();
    this.cursorTimerCount = 0;
    this.cursorInterval = setInterval(::this.cursorTimerCheck, 1000);
  }

  componentWillReceiveProps (nextProps, nextContext) {
    this._createTOC(nextProps);
    const {
      params,
      session,
      deckState,
      showHUD,
      hideHUD,
      history,
      levelId
    } = nextContext;
    const { slide: paramsSlide } = params;
    const { mode } = session;
    const { displayHUD } = deckState;
    if (mode && !displayHUD) {
      showHUD();
    }

    if (session) {
      const {lastSlide, currentSlide, currentLevel, completedLevel} = session;
      const slide = this._getSlideIndex();
      this.setState({
        lastSlide: slide
      });
      if (!currentSlide) {
        if (lastSlide && currentLevel !== 'prep' && parseInt(currentLevel, 10) === (completedLevel || 0) + 1) {
          nextContext.setCurrentSlide(lastSlide);
        } else if (levelId === currentLevel) {
          this._firstSlide();
        }
      } else if (!currentLevel) {
        this._setLevel(levelId);
      } else if (currentSlide &&
          this.context.session.currentLevel &&
          this.context.slide &&
          (String(currentSlide) !== String(this.context.slide) ||
          String(paramsSlide) !== String(currentSlide) ||
          mode !== this.context.session.mode ||
          currentLevel !== this.context.session.currentLevel ||
          levelId !== String(currentLevel))) {
        const suffix = mode ? `?mode=${mode}` : '';
        const newPath = this._getMountPoint() + currentSlide + suffix;
        if (newPath !== this.oldPath) {
          setTimeout(() => {
            history.replaceState(null, newPath);
          }, 0);
        }
        if (!mode && this.context.session.mode) {
          hideHUD();
        }
        this.oldPath = newPath;
      }
    }
  }

  componentWillUnmount () {
    this._detachEvents();
    clearInterval(this.cursorInterval);
  }

  cursorTimerCheck () {
    const { hideCursor } = this.state;
    // If mouse hasn't been moved for 10 seconds, then hide it

    this.cursorTimerCount++;
    if (this.cursorTimerCount > 10 && !hideCursor) {
      this.setState({
        hideCursor: true
      });
    }
  }

  mouseMove () {
    this.cursorTimerCount = 0;
    this.setState({
      hideCursor: false
    });
  }

  _mapChildren (prefix, children) {
    let numericId = 0;
    const childrenArray = Children.toArray(children);
    const entries = childrenArray.map(child => {
      numericId++;
      const id = prefix + (child.props.id ? child.props.id : numericId);
      if (child.type.displayName === 'Slide') {
        return {
          id,
          slide: child
        };
      } else if (child.type.displayName === 'Section') {
        return this._mapChildren(
          id + ':',
          child.props.children
        );
      } else {
        throw new Error('Unexpected child component');
      }
    });
    return entries;
  }

  _createTOC (props) { // Table of Contents
    const nestedEntries = this._mapChildren('', props.children);
    const entries = lodash.flatten(nestedEntries);
    this.TOC = entries;
  }

  _attachEvents () {
    window.addEventListener('keydown', this._handleKeyPress);
    window.addEventListener('load', this._getDeckHeight);
    window.addEventListener('resize', this._getDeckHeight);
  }

  _detachEvents () {
    window.removeEventListener('keydown', this._handleKeyPress);
    window.removeEventListener('load', this._getDeckHeight);
    window.removeEventListener('resize', this._getDeckHeight);
  }

  _getDeckHeight () {
    this.setState({
      deckHeight: window.innerHeight
    });
  }

  _handleKeyPress (evt) {
    const event = window.event ? window.event : evt;
    // left, page down
    if (event.keyCode === 37 || event.keyCode === 33) {
      this._prevSlide();
    }
    // right, page up
    if (event.keyCode === 39 || event.keyCode === 34) {
      this._nextSlide();
    }
    // return/enter
    if (event.keyCode === 13) {
      this._toggleHUD();
    }
    /*
    if (event.keyCode === 80 && !event.ctrlKey && !event.metaKey) { // o
      this._togglePresenterMode();
    }
    */
  }

  _getTouchEvents () {
    const self = this;

    return {
      onTouchStart(evt) {
        self.touchObject = {
          startX: evt.touches[0].pageX,
          startY: evt.touches[0].pageY
        };
      },
      onTouchMove(evt) {
        const direction = self._swipeDirection({
          x1: self.touchObject.startX,
          x2: evt.touches[0].pageX,
          y1: self.touchObject.startY,
          y2: evt.touches[0].pageY
        });

        self.touchObject = {
          startX: self.touchObject.startX,
          startY: self.touchObject.startY,
          endX: evt.clientX,
          endY: evt.clientY,
          length: Math.round(
            Math.sqrt(
              Math.pow(evt.touches[0].pageX - self.touchObject.startX, 2)
            )
          ),
          direction
        };

        if (direction !== 0) {
          evt.preventDefault();
        }
      },
      onTouchEnd(evt) {
        self._handleSwipe(evt);
      },
      onTouchCancel(evt) {
        self._handleSwipe(evt);
      }
    };
  }

  _handleSwipe () {
    if (typeof (this.touchObject.length) !== 'undefined' &&
        this.touchObject.length > 44) {
      this.clickSafe = true;
    } else {
      this.clickSafe = false;
    }

    if (Math.abs(this.touchObject.length) > 20) {
      if (this.touchObject.direction === 1) {
        this._nextSlide();
      } else if (this.touchObject.direction === -1) {
        this._prevSlide();
      }
    }

    this.touchObject = {};
  }

  _swipeDirection (touch) {
    const xDist = touch.x1 - touch.x2;
    const yDist = touch.y1 - touch.y2;
    const radians = Math.atan2(yDist, xDist);
    let swipeAngle = Math.round(radians * 180 / Math.PI);

    if (swipeAngle < 0) {
      swipeAngle = 360 - Math.abs(swipeAngle);
    }
    if ((swipeAngle <= 45) && (swipeAngle >= 0)) {
      return 1;
    }
    if ((swipeAngle <= 360) && (swipeAngle >= 315)) {
      return 1;
    }
    if ((swipeAngle >= 135) && (swipeAngle <= 225)) {
      return -1;
    }

    return 0;
  }

  _togglePresenterMode () {
    const { presenter, history, slide } = this.context;
    const suffix = presenter ? '' : '?presenter';
    const mountPoint = this._getMountPoint();
    history.replaceState(
      null,
      mountPoint + slide + suffix
    );
  }

  _getMountPoint () {
    const { sessionId, session: { currentLevel } } = this.context;
    return `/class/${sessionId}/content/${currentLevel}/`;
  }

  _firstSlide () {
    if (this.TOC.length === 0) return;
    const { setCurrentSlide, setLastSlide } = this.context;
    const slideId = this._getHash(0);
    setLastSlide(slideId);
    setCurrentSlide(slideId);
  }

  _setLevel (levelId) {
    const { setCurrentLevel } = this.context;
    setCurrentLevel(levelId);
  }

  _stopPropagation (evt) {
    if (evt) {
      evt.preventDefault();
      evt.stopPropagation();
      evt.nativeEvent.stopPropagation();
    }
  }

  _prevSlide (evt) {
    const { setCurrentSlide, setLastSlide } = this.context;
    const slide = this._getSlideIndex();
    this._stopPropagation(evt);
    this.setState({
      lastSlide: slide
    });
    if (slide > 0) {
      const slideId = this._getHash(slide - 1);
      setLastSlide(slideId);
      setCurrentSlide(slideId);
    }
  }

  _nextSlide (evt) {
    this._stopPropagation(evt);
    return this.__nextSlide();
  }

  __nextSlide (force) {
    const { setCurrentSlide, setLastSlide, i18n: _ } = this.context;
    const slide = this._getSlideIndex();
    this.setState({
      lastSlide: slide
    });
    if (!force && this.TOC[slide].id === 'mission-report:report') {
      const {missionReports, completedLevel, currentLevel} = this.context.session;
      const missionReport = missionReports && missionReports[`L${currentLevel}`];
      if (!missionReport || this._hasEmptyOrInvalidAnswer(missionReport)) {
        this.setState({nextSlideConfirmationModal: {
          title: _('Mission Report'),
          message: _('Please fill out the Mission Report, as it helps us share the impact of the program with our funders!'),
          cancelBtnMessage: _('OK'),
          continueBtnMessage: _('I\'m just previewing')
        }});
        return;
      }
      const _currentLevel = parseInt(currentLevel, 10);
      const isNotCompleted = completedLevel < _currentLevel;
      const isLastLevel = this.context.program.levels[_currentLevel+1] === undefined;
      console.log(isNotCompleted, isLastLevel);
      if (isNotCompleted && isLastLevel) {
        this.context.completeLevel(currentLevel, true);
      }
    }
    if (slide < this.TOC.length - 1) {
      const slideId = this._getHash(slide + 1);
      setLastSlide(slideId);
      setCurrentSlide(slideId);
    }
  }

  _hasEmptyOrInvalidAnswer(missionReport) {
    return Object.keys(missionReport).some(k => missionReport[k].invalid || typeof missionReport[k].answer !== 'number')
  }

  _getHash (slide) {
    return this.TOC[slide].id;
  }

  _toggleHUD (evt) {
    this._stopPropagation(evt);
    const { deckState, showHUD, hideHUD } = this.context;
    const { displayHUD } = deckState;
    if (displayHUD) {
      hideHUD();
    } else {
      showHUD();
    }
  }

  _getSlideIndexForSlideId (slideId) {
    const index = lodash.findIndex(this.TOC, entry => {
      return String(entry.id) === String(slideId);
    });
    return index >= 0 ? index : 0;
  }

  _getSlideIndex () {
    return this._getSlideIndexForSlideId(this.context.slide);
  }

  _renderSlide () {
    const slide = this._getSlideIndex();
    const child = this.TOC[slide].slide;
    return React.cloneElement(child, {
      key: 'slide ' + slide,
      hash: this.context.slide,
      currentSlide: this.context.slide,
      slideIndex: slide,
      lastSlide: this.state.lastSlide,
      transition: child.props.transition.length ?
        child.props.transition :
        this.props.transition,
      transitionDuration: child.props.transition.transitionDuration ?
        child.props.transitionDuration :
        this.props.transitionDuration,
      getSlideIndexForSlideId: this._getSlideIndexForSlideId.bind(this)
    });
  }

  handleNextSlideConfirmation(_continue) {
    this.setState({nextSlideConfirmationModal: null});
    if (_continue) this.__nextSlide(true);
  }

  render () {
    const { session, location, deckState, setMode, program } = this.context;
    const { mode, currentLevel } = session;
    const { displayHUD: displayHUDDeckState } = deckState;
    const displayHUD = (currentLevel === 'prep') ? false : displayHUDDeckState;
    const displayHUDToggle = (currentLevel !== 'prep');
    const displayArrows = (currentLevel === 'prep') ? true : displayHUD;
    const displayExit = (currentLevel === 'prep');
    const { deckHeight, hideCursor } = this.state;
    const slide = this._getSlideIndex();
    const styles = {
      showControls: {
        position: 'absolute',
        color: 'white',
        fontSize: '14px',
        padding: '5px',
        opacity: displayHUD ? 0 : 1,
        transition: 'opacity 0.4s ease-in'
      },
      deck: {
        backgroundColor: this.context.presenter ? 'black' : this.props.bgColor,
        color: 'white',
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100vh',
        cursor: hideCursor ? 'none' : 'default',
        overflow: 'hidden'
      },
      transition: {
        height: '100vh',
        width: '100%',
        perspective: 1000,
        transformStyle: 'flat'
      }
    };

    let componentToRender;
    if (this.context.presenter) {
      componentToRender = (
          <Presenter slides={this.props.children}
            slide={this._getSlideIndex()}
            TOC={this.TOC}
            prevSlide = {this._prevSlide.bind(this)}
            nextSlide = {this._nextSlide.bind(this)}
            getHash = {this._getHash.bind(this)} />
      );
      /*
      <Progress
        items={this.TOC}
        currentSlide={this._getSlideIndex()}
        type={this.props.progress} />
      */
    } else {
      componentToRender = (
        <div
            className="deck-fullscreen"
            style={styles.deck}>
          <HeadsUpDisplay
            slide={slide}
            displayHUD={displayHUD}
            displayHUDToggle={displayHUDToggle}
            displayArrows={displayArrows}
            displayExit={displayExit}
            pathname={location.pathname}
            TOC={this.TOC}
            currentSlide={this._getSlideIndex()}
            progressType={this.props.progress}
            prevSlide={::this._prevSlide}
            nextSlide={::this._nextSlide}
            mode={mode}
            deckHeight={deckHeight}
            setMode={setMode} />
          <TransitionGroup
              className="deck-slide-transition-group"
              component="div"
              style={[styles.transition]}>
            {this._renderSlide()}
          </TransitionGroup>
        </div>
      );
    }

    const { id: programId } = program;
    const wrappedComponent = (
      <div
        className={programId + ' deck-level-' + currentLevel + ' spectacle-deck'}
        style={[styles.deck]}
        onClick={this._toggleHUD}
        onMouseMove={::this.mouseMove}
        {...this._getTouchEvents()}>
        {componentToRender}
        {this.state.nextSlideConfirmationModal &&
        <NextSlideConfirmationModal
          showModal={true}
          closeModal={::this.handleNextSlideConfirmation}
          title={this.state.nextSlideConfirmationModal.title}
          message={this.state.nextSlideConfirmationModal.message}
          cancelBtnMessage={this.state.nextSlideConfirmationModal.cancelBtnMessage}
          continueBtnMessage={this.state.nextSlideConfirmationModal.continueBtnMessage} />
        }
        <Style rules={assign(this.context.styles.global, {})} />
      </div>
    );

    const { profile: { onboarding }, presenter } = this.context;
    if (enableOnboarding && currentLevel !== 'prep' && !onboarding && !presenter) {
      return (
        <Onboarding>
          {wrappedComponent}
        </Onboarding>
      );
    }
    return wrappedComponent;
  }
}

Deck.displayName = 'Deck';

Deck.defaultProps = {
  transitionDuration: 500,
  progress: 'pacman'
};

Deck.propTypes = {
  children: PropTypes.node,
  transition: PropTypes.array,
  transitionDuration: PropTypes.number,
  progress: PropTypes.oneOf(['pacman', 'bar', 'number', 'none']),
  bgColor: PropTypes.string
};

Deck.contextTypes = {
  styles: PropTypes.object,
  flux: PropTypes.object,
  history: PropTypes.object,
  location: PropTypes.object,
  presenter: PropTypes.bool,
  slide: PropTypes.string,
  session: PropTypes.object,
  sessionId: PropTypes.string,
  deckState: PropTypes.object,
  showHUD: PropTypes.func,
  hideHUD: PropTypes.func,
  setMode: PropTypes.func,
  setCurrentLevel: PropTypes.func,
  setCurrentSlide: PropTypes.func,
  setLastSlide: PropTypes.func,
  levelId: PropTypes.string,
  level: PropTypes.object,
  params: PropTypes.object,
  program: PropTypes.object,
  profile: PropTypes.object,
  completeLevel: PropTypes.func,
  i18n: PropTypes.func
};

Deck.childContextTypes = {
  togglePresenterMode: PropTypes.func
};

export default Deck;



// WEBPACK FOOTER //
// ./src/views/session/presentation/spectacle-ppa/src/deck.jsx